"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const uris_1 = require("../../globals/uris");
const autocontrol_1 = require("../autocontrol");
/**
 * Random control outputs random values between 0 and 1.
 */
class RandomControl extends autocontrol_1.AutoControl {
    constructor(uri, store) {
        super(uri, uris_1.RANDOM, store);
        this.store.setControlParam(this.uri, uris_1.AUTO_CONTROL_TRIGGER, 1);
    }
    update() {
        this.updateValue(Math.random());
    }
}
exports.RandomControl = RandomControl;



//////////////////
// WEBPACK FOOTER
// ./~/dymo-core/lib/controls/auto/randomcontrol.js
// module id = 1293
// module chunks = 3